var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrashLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.001 4.40869L3 4.4087",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0918 8.22754V13.3188",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9102 8.22754V13.3188",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7288 4.4087V16.5004C15.7288 16.6692 15.6617 16.8311 15.5424 16.9505C15.423 17.0698 15.2612 17.1369 15.0924 17.1369H4.90985C4.74106 17.1369 4.57919 17.0698 4.45984 16.9505C4.34049 16.8311 4.27344 16.6692 4.27344 16.5004V4.40869",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1824 4.40891V3.1361C13.1824 2.79853 13.0483 2.47478 12.8096 2.23608C12.5709 1.99738 12.2472 1.86328 11.9096 1.86328H8.09118C7.7536 1.86328 7.42986 1.99738 7.19116 2.23608C6.95246 2.47478 6.81836 2.79853 6.81836 3.1361V4.40891",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrashLight);
export default __webpack_public_path__ + "static/media/icon_trash_light.f53dca02410ff7e7595f53bac75724cd.svg";
export { ForwardRef as ReactComponent };